import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import { Avatar, Button, Stack, Grid } from "@mui/material";
import Box from "@mui/material/Box";
import React from "react";
import "./Header.css";
import { Link, useHistory } from "react-router-dom";

const Header = ({ children, hasHiddenAuthButtons }) => {
  let history = useHistory();
  const username = localStorage.getItem("username");

  const handleButtonClick = (event) => {
    let target = event.target;
    if (target.id === "Back to explore") {
      history.push("/");
    } else if (target.id === "login") {
      history.push("/login");
    } else if (target.id === "register") {
      history.push("/register");
    } else if (target.id === "logout") {
      localStorage.clear();
      window.location.reload();
    }
  };

  return (
    <Box className="header">
      <Box className="header-title">
        <Link to="/">
          <img src="logo_light.svg" alt="QKart-icon"></img>
        </Link>
      </Box>
      {hasHiddenAuthButtons ? (
        <Button
          className="explore-button"
          startIcon={<ArrowBackIcon />}
          variant="text"
          id="Back to explore"
          onClick={handleButtonClick}
        >
          Back to explore
        </Button>
      ) : username ? (
        <>
          <Box sx={{ width: 500 }}>{children}</Box>
          <Stack direction="row" spacing={1}>
            <Grid
              direction="row"
              justifyContent="center"
              alignItems="center"
              container
              spacing={2}
            >
              <Grid item md={4}>
                <Avatar
                  src="avatar.png"
                  alt="crio.do"
                  sx={{ height: 40, width: 45 }}
                />
              </Grid>
              <Grid item md={8}>
                {username}
              </Grid>
            </Grid>
            <Button id="logout" onClick={handleButtonClick}>
              Logout
            </Button>
          </Stack>
        </>
      ) : (
        <>
          <Box sx={{ width: 500 }}>{children}</Box>
          <Stack direction="row" spacing={1}>
            <Button id="login" onClick={handleButtonClick}>
              Login
            </Button>
            <Button
              id="register"
              variant="contained"
              onClick={handleButtonClick}
            >
              Register
            </Button>
          </Stack>
        </>
      )}
    </Box>
  );
};

export default Header;
